import React from "react";

interface MobileWebCamBypassModalProps {
  open: boolean;
  onContinue: () => void;
}

const MobileWebCamBypassModal: React.FC<MobileWebCamBypassModalProps> = ({ open, onContinue }) => {
  const handleRetry = () => {
    if (typeof window === "undefined") return;
    window.location.reload();
  };

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 px-4">
      <div className="w-full max-w-md rounded-3xl bg-white p-8 shadow-2xl">
        <div className="flex flex-col text-center">
          <h3 className="mb-3 text-2xl font-semibold text-slate-900">Unable to connect mobile webcam</h3>
          <p className="mb-6 text-sm leading-relaxed text-slate-600">
            We couldn’t connect to your mobile camera. You can retry the connection or skip and continue with just your
            laptop camera.
          </p>

          <div className="mt-2 flex flex-row items-center gap-3">
            <button
              onClick={handleRetry}
              className="flex-1 rounded-xl border border-slate-300 px-4 py-3 text-sm font-semibold text-slate-600 transition hover:border-slate-400 hover:text-slate-900 focus:outline-none focus:ring-2 focus:ring-slate-300 focus:ring-offset-2"
              type="button"
            >
              Retry
            </button>

            <button
              onClick={onContinue}
              className="flex-1 rounded-xl bg-gray-800 px-4 py-3 text-sm font-semibold text-white transition hover:bg-gray-900 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
              type="button"
            >
              Skip and continue
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MobileWebCamBypassModal;


